import { createIntegrationAuthenticationConfigurationClassMixin } from './IntegrationAuthenticationConfigurationMixin';

export interface ApiKeyConfigurationValid {
    type: 'API_KEY_VALID';
    token: string;
}

export interface ApiKeyConfigurationMissing {
    type: 'API_KEY_MISSING';
}

export type ApiKeyConfigurationUnion =
    | ApiKeyConfigurationMissing
    | ApiKeyConfigurationValid;

export class ApiKeyConfiguration extends createIntegrationAuthenticationConfigurationClassMixin<
    ApiKeyConfigurationUnion,
    'API_KEY'
>('API_KEY') {}
